import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
const CopiedMessage = ({ justCopied }) => {
    const { t } = useTranslation();
    return (_jsx("div", { className: `copied-message${justCopied ? ' just-copied' : ''}`, children: t('admin.copied_message') }));
};
export default CopiedMessage;
